import { FutureContractStatus } from "@/constants/entity-status";
import { TipoMoneda } from "@/constants/enums";
import { FutureContractDetail } from "@/pages/grain-requests/future-contract/schema/future-contract.schema";
import { AppColors } from "@/styles/colors";
import { formatCurrency } from "@/utils/format-currency";
import { Flex, GridItem, Text } from "@chakra-ui/react";

interface FinalPriceCardProps {
  futureContract?: FutureContractDetail | null;
}

export const FinalPriceCard = ({
  futureContract,
}:  FinalPriceCardProps) => {
  const precioFinalNumber = Number(futureContract?.precioFinal);

  if (
    futureContract?.precioFinal == null ||
    Number.isNaN(precioFinalNumber) ||
    precioFinalNumber <= 0 ||
    futureContract?.estado != FutureContractStatus.CONFIRMED
  ) {
    return null;
  }

  
    const getTipoMoneda = () => {
  
      if (futureContract?.tipoMoneda === TipoMoneda.ARS) return "$"
      if (futureContract?.tipoMoneda === TipoMoneda.USD) return "U$D"
      return TipoMoneda[futureContract?.tipoMoneda as keyof typeof TipoMoneda];
    };
  return (
    <GridItem>
      <Flex
        minH={"82px"}
        gap="10px"
        padding="12px"
        flexDir="column"
        borderRadius="12px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Text
          fontWeight={700}
          textTransform="uppercase"
          fontSize="12px"
          color={AppColors.GRAY_TEXT}
        >
          Precio final
        </Text>
        <Flex alignItems="center" gap="8px">
          <Text
            fontSize={{
              base: "15px",
              sm: "15px",
              md: "15px",
              lg: "18px",
              xl: "20px",
            }}
            fontWeight={700}
          >
            {`${getTipoMoneda()} ${formatCurrency(futureContract?.precioFinal)}`}
          </Text>
        </Flex>
      </Flex>
    </GridItem>
  );
};
